exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table thead th[data-v-7f5fb653] {\n  vertical-align: baseline;\n}\n", ""]);

// exports
